'use strict';
DoohApps
    .directive('validateEmail', ['$rootScope', function ($rootScope) {
        return {
            require: 'ngModel',
            restrict: 'A',
            scope: {
                errorObject: '=validateEmail'
            },
            link: function (scope, elem, attrs, ctrl) {
                //remove listed errors on change
                if (scope.errorObject && scope.errorObject.errorTypes) {
                    elem.bind('change', function () {
                        angular.forEach(scope.errorObject.errorTypes, function (val) {
                            ctrl.$setValidity(val, true);
                        });
                    });
                }

                if (ctrl && ctrl.$validators.email) {
                    ctrl.$validators.email = function (modelValue) {
                        return ctrl.$isEmpty(modelValue) || $rootScope.REGEX.EMAIL_REGEXP.test(modelValue);
                    };
                }
            }
        };
    }]);